import React from 'react';
import './About.css';
import bannerImg from '../assets/color-1867371_1920.jpg';
import { FaLeaf, FaSeedling, FaTint, FaTree } from 'react-icons/fa';

function About() {
  return (
    <div className="about-page">
      {/* Banner Section */}
      <div className="about-banner" style={{ backgroundImage: `url(${bannerImg})` }}>
        <div className="container">
          <div className="about-banner-content">
            <h1>About Our Nurseries</h1>
            <p>Learn about our mission, vision, and values</p>
          </div>
        </div>
      </div>

      {/* About Services Section */}
      <section className="about-services">
        <div className="about-intro">
          <h2>About Us</h2>
          <h3>The Best Services</h3>
          <p>
            Located in the heart of the Lower Mainland, Peel Native Plants Ltd. proudly specializes in the propagation and cultivation of top-quality BC native plants. Our plants are ideal for commercial and residential landscapes, habitat and wetland restoration, stream rehabilitation, mitigation projects, highways, parks, and more.
          </p>
          <p>
            With one of the largest inventories in the region and unmatched growing capabilities, we are ready to supply all your wholesale native plant needs — big or small!
          </p>
          <p>
            At Peel Native Plants, we’re passionate about delivering exceptional plants and outstanding customer service. Let’s grow success together!
          </p>
        </div>

        <div className="services-grid">
          <div className="service-box">
            <FaTree className="service-icon" />
            <h4>Garden Care</h4>
            <p>We ensure your landscape flourishes with healthy native plants.</p>
          </div>
          <div className="service-box">
            <FaLeaf className="service-icon" />
            <h4>Plant Renovation</h4>
            <p>Restoring old greenspaces with fresh growth and expert planning.</p>
          </div>
          <div className="service-box">
            <FaSeedling className="service-icon" />
            <h4>Seed Supply</h4>
            <p>High-quality native seeds selected for local conditions.</p>
          </div>
          <div className="service-box">
            <FaTint className="service-icon" />
            <h4>Watering Support</h4>
            <p>Efficient irrigation strategies for thriving plants year-round.</p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default About;
